// Zentrale Anzeige-Formatierung für Preise in der Weboberfläche (Issue):
// deutsches Zahlenformat mit Tausenderpunkt, Dezimalkomma, immer zwei
// Nachkommastellen und einem Leerzeichen vor dem Euro-Zeichen.
//
// Beispiele:
//   924      -> "924,00 €"
//   2064     -> "2.064,00 €"
//   3153.6   -> "3.153,60 €"
//   12345.5  -> "12.345,50 €"
//
// Reine Darstellungsfunktion – keine Preisberechnung. Der Wert darf eine Zahl
// oder ein numerischer String (z. B. Ergebnis von toFixed) sein.
export function formatEuroPrice(value) {
  const number = Number(value);
  const safeNumber = Number.isFinite(number) ? number : 0;
  const formatted = new Intl.NumberFormat("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(safeNumber);
  return `${formatted} €`;
}
